import { render, staticRenderFns } from "./ModalEditarUrlEndpointRequisicao.vue?vue&type=template&id=4253493e&scoped=true"
import script from "./ModalEditarUrlEndpointRequisicao.vue?vue&type=script&lang=js"
export * from "./ModalEditarUrlEndpointRequisicao.vue?vue&type=script&lang=js"
import style0 from "./ModalEditarUrlEndpointRequisicao.vue?vue&type=style&index=0&id=4253493e&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4253493e",
  null
  
)

export default component.exports